'use client';

import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';

import type { Theme, ThemeOptions } from '@mui/material/styles';
import type { FC, PropsWithChildren } from 'react';

interface ThemeProviderProps extends PropsWithChildren {
  palette?: ThemeOptions['palette'];
  typography?: ThemeOptions['typography'];
  spacing?: ThemeOptions['spacing'];
  zIndex?: ThemeOptions['zIndex'];
  direction?: ThemeOptions['direction'];
  shape?: ThemeOptions['shape'];
  shadows?: ThemeOptions['shadows'];
  transitions?: ThemeOptions['transitions'];
  breakpoints?: ThemeOptions['breakpoints'];
  components?: ThemeOptions['components'];
  responsiveFontSizes?: boolean;
  theme?: ThemeOptions;
}

// eslint-disable-next-line max-statements
export const ThemeProvider: FC<ThemeProviderProps> = ({
  children,
  theme: themeOptions = {},
  ...props
}) => {
  const options: ThemeOptions = { ...themeOptions, ...props };

  let theme: Theme = createTheme( options );

  if ('responsiveFontSizes' in props) {
    theme = responsiveFontSizes( theme );
  }

  return (
    <MUIThemeProvider theme={theme}>
      {children}
    </MUIThemeProvider>
  );
};
